import * as React from 'react'
export const SvgSearchIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} {...props}>
    <path d="M10.113 16.198a6.085 6.085 0 100-12.17 6.085 6.085 0 000 12.17zm0 2.028a8.113 8.113 0 110-16.226 8.113 8.113 0 010 16.226zM23 21.566L21.566 23l-5.07-5.07 1.433-1.435L23 21.565z" />
  </svg>
)
export default SvgSearchIcon
